import { CardType } from './ZdarPexesoCipher';
import React from 'react';
import cover from '../../../../assets/images/games/zdar-kids-game/memory-game/cover.webp';

type Props = {
    card: CardType;
    handleChoice: (card: CardType) => void;
    flipped: boolean;
    disabled: boolean;
};
function SingleCard({ card, handleChoice, flipped, disabled }: Props) {
    const handleClick = () => {
        !disabled && handleChoice(card);
    };
    return (
        <React.Fragment>
            <div className="memory-game-card">
                <div className={flipped ? 'memory-game-flipped' : ''}>
                    <img src={card.src} className="memory-game-front" alt="card front" />
                    <img src={cover} className="memory-game-back" alt="card back" onClick={handleClick} />
                </div>
            </div>
        </React.Fragment>
    );
}

export default SingleCard;
